import React from 'react';
import { FDList } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import Divider from 'Components/UI/Divider';
import { MatchesSearchTerm } from './ScenarioSelectionAssumptionSections';
import ScenarioSelectionAssumptionSectionLineItem from './ScenarioSelectionAssumptionSectionLineItem';


const ScenarioSelectionAssumptionSectionLineItems = ({ collection, searchTerm, alwaysShow }) => {
  const resources = collection.resources().list().filter((resource) => {
    if (alwaysShow) {
      return true;
    }

    return MatchesSearchTerm(resource.attr('title'), searchTerm);
  });

  return (
    <FDList>
      {resources.map((resource, idx) => (
        <>
          <Divider />
          <ScenarioSelectionAssumptionSectionLineItem resource={resource} />
          {idx === resources.length - 1 && <Divider />}
        </>
      ))}
    </FDList>
  );
};

ScenarioSelectionAssumptionSectionLineItems.defaultProps = {};

ScenarioSelectionAssumptionSectionLineItems.propTypes = {
  collection: PropTypes.object.isRequired,
  searchTerm: PropTypes.string.isRequired,
  alwaysShow: PropTypes.bool,
};

export default ScenarioSelectionAssumptionSectionLineItems;
